<template lang="jade">
  .container-fluid
    .row
      .status_main.col-md-12
        header.config_title_bar.main_title_bar.clearfix
          h1.title.col-md-2.col-lg-2.col-sm-2.col-xs-3.clearfix
            | Status
            //- for viewport debug
          //- .load_wrap.col-lg-2.col-lg-offset-3.col-md-2.col-md-offset-3.col-sm-1.col-sm-offset-3.col-xs-2.col-xs-offset-0(v-if="true")
          .load_wrap.col-lg-2.col-lg-offset-3.col-md-2.col-md-offset-3.col-sm-1.col-sm-offset-3.col-xs-2.col-xs-offset-0(v-if="showLoadingProfile")
            .load-6
              .letter-holder
                .l-1.letter
                  |L
                .l-2.letter
                  |o
                .l-3.letter
                  |a
                .l-4.letter
                  |d
                .l-5.letter
                  |i
                .l-6.letter
                  |n
                .l-7.letter
                  |g
                .l-8.letter
                  |.
                .l-9.letter
                  |.
                .l-10.letter
                  |.
          .window_setting.col-lg-2.col-md-2.col-xs-2.row_space--xxs.pull-right
            i.fa.fa-cog.fa-2x(v-on:click='showOutSetting=true')
        section.status_content
          section.screen_block.clearfix.col-md-12.col-lg-12.no_pad
            section.screen_section.col-xs-12.col-sm-7.col-md-7.col-lg-8.row_space--xxs.no_pad.clearfix
              v-screen(v-bind:out-ratio.sync='outRatio'
                       v-bind:splits.sync='splits'
                       v-bind:out-resolution.sync='outResolution'
                       v-bind:out-resolution-options.sync='outResolutionOptions'
                       v-bind:out-layout.sync='outLayout'
                       v-bind:which-split.sync='whichSplit'
                       v-bind:editable='false'
                       v-bind:layer.sync='splitLayer'
                       v-bind:show-Ps='true'
                       v-bind:label.sync='label'
                       v-bind:mapping.sync='mapping'
                       v-bind:show-link='true')
            section.function_section.col-xs-12.col-sm-5.col-md-5.col-lg-4.clearfix.no_pad-xxs
              .col-xs-12.col-md-12.full_screen_btn_group.col-centered.clearfix.no_pad-xxs
                header.row_space--xxs.hidden-xs
                  label Full Screen
                .col-xs-3.col-sm-3.col-md-3.full__btn__single.clearfix(v-for='(key,opt) in fullScreenOptions')
                  button.btn.btn-default.clearfix.btn-square-xs(v-on:click="sendKeyToDevice(opt.splitOptionKey)" v-bind:disabled="in4K || buttonDisabled")
                    |{{opt.label}}
              .col-xs-12.col-md-12.quick_selection_btn_group.col-centered.clearfix.no_pad-xxs
                header.row_space--xxs.hidden-xs
                  label Quick Selection
                .quick__btn__single.pull-left(v-for='(key, opt) in quickSelectionOptions' )
                  button.btn.btn-default.clearfix.btn-square-xs(v-on:click="sendKeyToDevice(opt.splitOptionKey)" v-bind:disabled="in4K || buttonDisabled")
                    img.icon(v-bind:src='icons.quick[key]')
                //- .quick__btn__single.pull-left(v-for='(key, opt) in quickSelectionOptions' )
                //-   button.btn.btn-default.col-xs-12.pull-left.clearfix.btn-square-xs(v-on:click="changeProps('quick', opt.value, opt.splitOptionKey)")
                //-     img.icon(v-bind:src='icons.quick[key]')
              .col-xs-12.col-md-12.custom_btn_group.col-centered.clearfix
                header.row_space--xxs.hidden-xs
                  label Custom Preset
                .custom__btn__single.col-xs-3.col-sm-3.col-md-3.clearfix(v-for='opt in customProfileOptions' )
                  button.btn.btn-default.btn-square-xs.no_pad(v-on:click="changeProps('custom', opt.value, opt.value)" v-bind:disabled="in4K || buttonDisabled")
                    span
                      i.fa.fa-user
                        |&nbsp;{{opt.label}}
                    br
                    span.profile_name {{opt.name}}
      modal(title='Settings'
            v-bind:show.sync='showOutSetting'
            effect='fade'
            ok-text='Apply'
            cancel-text='Cancel'
            backdrop='false').window_setting_modal
        .modal-header(slot='modal-header')
          button.close(v-on:click='showOutSetting = false' v-bind:disabled.sync='isUpdatingProfile')
            span &times;
          h4.modal-title Settings
        .modal-body.clearfix(slot='modal-body')
          tabs
            tab(header='Source')
              section.source_sec.clearfix.col-md-12.outer_group
                .col-md-12
                  h3.title Source Setting
                label.col-xs-12.clearfix
                  | Name
                .col-xs-12.col-sm-6.clearfix.source__single
                  label Source1:
                  input.form-control(type="text" v-model="editing.sourceLabel[1].text")
                .col-xs-12.col-sm-6.clearfix.source__single
                  label Source2:
                  input.form-control(type="text" v-model="editing.sourceLabel[2].text")
                .col-xs-12.col-sm-6.clearfix.source__single
                  label Source3:
                  input.form-control(type="text" v-model="editing.sourceLabel[3].text")
                .col-xs-12.col-sm-6.clearfix.source__single
                  label Source4:
                  input.form-control(type="text" v-model="editing.sourceLabel[4].text")
                .col-xs-3.col-xs-offset-9.col-sm-3.col-sm-offset-9.row_space--xs
                  button.btn.btn-primary.pull-right(v-on:click='applySourceLabel' v-bind:disabled.sync='isUpdatingProfile')
                    | Apply
            tab(header='Output')
              section.resolution_sec.clearfix.col-md-12.outer_group
                .col-md-12
                  h3.title Output Setting
                .col-xs-12.col-sm-12.clearfix
                  label.col-xs-4.no_pad Output Resolution:&nbsp;
                  v-select(v-bind:options='computedOutResolutionOptions' v-bind:value.sync='editing.outResolution')
                .col-xs-12.col-sm-12.row_space--xs
                  span.pull-left.reminding(v-if="isUpdatingProfile") Updating all preset..., this might take about 30secs
                  button.btn.btn-primary.pull-right(v-on:click='applyOutputResolution' v-bind:disabled.sync='isUpdatingProfile') Apply
            //- tab(header='Color' disabled)
              section.screen_sec.clearfix.col-md-12
                .col-md-12
                  h3.title Color
                .col-xs-12.no_pad.color_group.outer_group
                  .col-xs-12.col-sm-6.clearfix.color__single
                    label Brightness: {{editing.outColor.brightness}}
                    input.form-control#brightness(type='range' max=100 min=0 v-model='editing.outColor.brightness')
                  .col-xs-12.col-sm-6.clearfix.color__single
                    label Saturation: {{editing.outColor.saturation}}
                    input.form-control#saturation(type='range' max=100 min=0 v-model='editing.outColor.saturation')
                  .col-xs-12.col-sm-6.clearfix.color__single
                    label Contrast: {{editing.outColor.contrast}}
                    input.form-control#contrast(type='range' max=100 min=0 v-model='editing.outColor.contrast')
                  .col-xs-12.col-sm-6.clearfix.color__single.row_space--sm
                    button.btn.btn-primary.pull-right(v-on:click="applySingleAPI('dxSetOutputColor', 'outColor', 'color')") Apply
            //- tab(header='Effect' disabled)
              section.col-xs-12.clearfix.effect_group.outer_group.effect_sec
                .col-md-12
                  h3.title Effect
                .col-xs-4.clearfix.effect__single
                  label Vertical Flip:
                .col-xs-6.clearfix.effect__single
                  label.iosCheck
                    input(type='checkbox' v-model='editing.outVideo.verticalFlip')
                    i
                .col-xs-4.clearfix.effect__single
                  label Mirror:
                .col-xs-6.clearfix.effect__single
                  label.iosCheck
                    input(type='checkbox' v-model='editing.outVideo.mirror')
                    i
                .col-xs-2
                  button.btn.btn-primary.pull-right(v-on:click="applySingleAPI('dxSetOutputVideo', 'outVideo', 'video')") Apply
            tab(header="Sound")
              section.sound_sec.clear-fix.outer_group.col-md-12
                .col-md-12
                  h3.title Sound
                .col-xs-12.sound__single
                  label.col-xs-5.col-md-4.no_pad.clear-right Sound from:
                  v-select.col-xs-7(v-bind:options='soundFromOptions' v-bind:value.sync='editing.outSound.soundFrom')
                .col-xs-12.sound__single
                  label.col-xs-5.col-md-4.no_pad.clear-right R/L Channel:
                  v-select.col-xs-7(v-bind:options='channelOptions' v-bind:value.sync='editing.outSound.soundRLChannel')
                .fa_checkbox.col-xs-12
                  input#audio(type='checkbox' v-model='editing.outSound.fullScreenAudio')
                  label(for='audio')
                    span Audio follows Windows when full screen
                .fa_checkbox.col-xs-12
                  input#mute(type='checkbox' v-model='editing.outSound.mute')
                  label(for='mute')
                    span Mute
                .col-xs-12
                  button.btn.btn-primary.pull-right(v-on:click="applySingleAPI('dxSetOutputSound', 'outSound', 'sound')" v-bind:disabled.sync='isUpdatingProfile') Apply
        .modal-footer.clearfix(slot='modal-footer')
          button.btn.btn-default(v-on:click="showOutSetting = false" v-bind:disabled.sync='isUpdatingProfile') Cancel
</template>

<script>
import { modal, tab } from 'vue-strap'
import tabset from 'src/components/Tabset.vue'
import { call } from 'src/Service.js'
import singleSelect from 'src/components/Single-Select.vue'
import scr from 'src/components/Screen.vue'
import _ from 'lodash'
import MobileDetect from 'mobile-detect'
import $ from 'jquery'

export default {
  components: {
    modal,
    tabs: tabset,
    tab,
    'v-select': singleSelect,
    'v-screen': scr
  },
  data () {
    return {
      isUpdatingProfile: false,
      showLoadingProfile: false,
      showOutSetting: false,
      icons: {
        full: [
          require('src/assets/img/icon/mixers/FullScreenA.png'),
          require('src/assets/img/icon/mixers/FullScreenB.png'),
          require('src/assets/img/icon/mixers/FullScreenC.png'),
          require('src/assets/img/icon/mixers/FullScreenD.png')
        ],
        quick: [
          require('src/assets/img/icon/mixers/QuickSelection-01.png'),
          require('src/assets/img/icon/mixers/QuickSelection-02.png'),
          require('src/assets/img/icon/mixers/QuickSelection-03.png'),
          require('src/assets/img/icon/mixers/QuickSelection-04.png'),
          require('src/assets/img/icon/mixers/QuickSelection-05.png')
        ]
      },
      splits: {
        setting: {
          '1': [],
          '2': [],
          '3': [],
          '4': []
        }
      },
      splitLayer: [],
      links: {},
      outResolutionOptions: {},
      outResolution: '',
      outResolutionChanged: false,
      outLayout: 'init', // init, quick , full or custom
      customSplit: '',
      fullScreenSplit: '',
      quickSelectSplit: '2*2',
      customOptions: [
        {label: '1', value: '1'},
        {label: '2', value: '2'},
        {label: '3', value: '3'},
        {label: '4', value: '4'},
        {label: '5', value: '5'},
        {label: '6', value: '6'},
        {label: '7', value: '7'},
        {label: '8', value: '8'}
      ],
      fullScreenOptions: [
        {label: 'A', value: '1', splitOptionKey: 'Full-A'},
        {label: 'B', value: '2', splitOptionKey: 'Full-B'},
        {label: 'C', value: '3', splitOptionKey: 'Full-C'},
        {label: 'D', value: '4', splitOptionKey: 'Full-D'}
      ],
      quickSelectionOptions: [
        {label: '2*2', value: '2*2', splitOptionKey: 'PAP1'},
        {label: '1*3_top', value: 't', splitOptionKey: 'PAP2'},
        {label: '1*3_bottom', value: 'b', splitOptionKey: 'PAP3'},
        {label: '1*3_left', value: 'l', splitOptionKey: 'PAP4'},
        {label: '1*3_right', value: 'r', splitOptionKey: 'PAP5'}
      ],
      soundFromOptions: [
        {label: 'Source 1', value: '1'},
        {label: 'Source 2', value: '2'},
        {label: 'Source 3', value: '3'},
        {label: 'Source 4', value: '4'}
      ],
      channelOptions: [
        {label: 'Channel 1&2', value: '1'},
        {label: 'Channel 3&4', value: '2'},
        {label: 'Channel 5&6', value: '3'},
        {label: 'Channel 7&8', value: '4'}
      ],
      outSound: {
        soundFrom: '1',
        soundRLChannel: '1',
        fullScreenAudio: false,
        mute: false
      },
      outSoundChanged: false,
      outVideo: {
        verticalFlip: true,
        mirror: false
      },
      outVideoChanged: false,
      outColor: {
        brightness: 50,
        contrast: 50,
        saturation: 50
      },
      outColorChanged: false,
      ww: 0,
      profiles: {},
      editing: {
        outSound: {},
        outColor: {},
        outVideo: {},
        outResolution: '',
        sourceLabel: {}
      },
      label: {},
      mapping: {},
      buttonDisabled: false
    }
  },
  async asyncData () {
    let { mac } = this.$route.params
    let newProfile = {}
    this.showLoadingProfile = true

    // save profile in $root to speed up
    if (!this.$root.mixerProfile) {
      this.$root.mixerProfile = {}
    }

    if (!this.$root.mixerProfile[mac]) {
      try {
        for (let i = 1; i < 9; i++) {
          console.log(i)
          let { profiles } = await call(mac, 'dxGetProfiles', {
            profile: i.toString()
          })
          newProfile[i] = profiles
        }

        this.profiles = _.cloneDeep(newProfile)
        this.$root.mixerProfile[mac] = newProfile
      } catch (err) {
        console.error(err)
      }
    } else {
      this.profiles = _.cloneDeep(this.$root.mixerProfile[mac])
    }

    call(mac, 'dxGetSplitArea').then(res => {
      this.splits = _.cloneDeep(res)
      return call(mac, 'dxGetOutputResolution')
    }).then(({resolution}) => {
      this.outResolution = resolution['1'] // remove toString() after unify the format
      return call(mac, 'dxGetOutputResolutionOptions')
    }).then(({options}) => {
      this.outResolutionOptions = options
      return call(mac, 'dxGetMixerStatus')
    }).then(({mapping}) => {
      this.mapping = mapping
      return call(mac, 'dxGetOutputVideo')
    }).then(({video}) => {
      this.outVideo = video
      return call(mac, 'dxGetOutputSound')
    }).then(({sound}) => {
      this.outSound = sound
      return call(mac, 'dxGetOutputColor')
    }).then(({color}) => {
      this.outColor = _.cloneDeep(color)
      return call(mac, 'dxGetLabel')
    }).then((label) => {
      this.label = label
      return call(mac, 'dxGetSplitLayer')
    }).then(({layer}) => {
      this.splitLayer = layer
      this.showLoadingProfile = false
      this.$broadcast('chgZindex', this.splitLayer, '1')
      this.$broadcast('render', '1')// wait until all asyncData loaded and then emit 'render'
    }).catch(err => {
      console.error(err)
      this.showLoadingProfile = false
      this.alert('danger', '', err)
    })
  },
  computed: {
    in4K () {
      return this.outResolutionOptions[this.outResolution] === '3840x2160@60' || this.outResolutionOptions[this.outResolution] === '1080 to 4K2K@60'
    },
    outRatio () {
      this.ww = window.innerWidth
      console.log('change www')
      let ratio = []
      switch (this.outResolutionOptions[this.outResolution]) {
        case '800x600':
        case '800x600@60':
        default:
          ratio = [4, 3, 200]  // [width, height, baseWidth]
          break
        case '3840x2160@60':
          ratio = [16, 9, 240]
          break
        case '1920x1200':
        case '1920x1200@60':
          ratio = [16, 10, 120]
          break
        case '1080 to 4K2K@60':
        case '1920x1080':
        case '1920x1080@60':
          ratio = [16, 9, 120]
          break
        case '1600x1200@60':
          ratio = [16, 12, 100]
          break
        case '1440x900@60':
          ratio = [8, 5, 180]
          break
        case '1400x900@60':
          ratio = [14, 9, 100]
          break
        case '1366x768@60':
          ratio = [16, 9, 85]
          break
        case '1280x1024@60':
          ratio = [5, 4, 256]
          break
        case '1280x960@60':
          ratio = [4, 3, 320]
          break
        case '1280x768@60':
          ratio = [5, 3, 256]
          break
        case '1280x720@60':
          ratio = [16, 9, 80]
          break
        case '1024x768@60':
          ratio = [4, 3, 256]
          break
        case '720x480@60':
          ratio = [3, 2, 240]
          break
        case '1680x1050@60':
          ratio = [8, 5, 210]
          break

        case '640x480':
        case '640x480@60':
          ratio = [4, 3, 160]
          break
      }
      let md = new MobileDetect(window.navigator.userAgent)
      if (md.mobile() !== null && window.innerWidth <= 768) {
        if (this.ww === 320) { // i5
          ratio.push(Math.round(280 / ratio[0]))
        } else if (this.ww === 375 || this.ww === 360) { // i6 && S5
          ratio.push(Math.round(320 / ratio[0]))
        } else if (this.ww === 414 || this.ww === 412 || this.ww === 411) { // i6+ && nexus 6P
          ratio.push(Math.round(360 / ratio[0]))
        } else if (this.ww === 568) { // i5 landscape
          ratio.push(Math.round(340 / ratio[0]))
        } else if (this.ww === 684) {
          ratio.push(Math.round(400 / ratio[0]))
        } else if (this.ww > 568 && this.ww <= 667) {
          ratio.push(Math.round(400 / ratio[0]))
        } else if (this.ww > 667 && this.ww <= 736) {
          ratio.push(Math.round(450 / ratio[0]))
        } else if (this.ww === 768) {
          ratio.push(Math.round(400 / ratio[0]))
        } else { // set 300 to others
          ratio.push(Math.round(300 / ratio[0]))
        }
      } else if (window.innerWidth > 768 && window.innerWidth < 992) {
        ratio.push(Math.round(450 / ratio[0])) // ipad UP
      } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
        ratio.push(Math.round(550 / ratio[0])) // md
      } else if (window.innerWidth >= 1200) {
        ratio.push(Math.round(800 / ratio[0])) // lg
      }
      return ratio
    },
    computedOutResolutionOptions () {
      let options = []
      let keys = Object.keys(this.outResolutionOptions)
      for (let key of keys) {
        options.push({
          label: this.outResolutionOptions[key],
          value: key
        })
      }
      return options
    },
    whichSplit () {
      if (this.outLayout === 'quick') {
        return this.quickSelectSplit
      } else if (this.outLayout === 'full') {
        return this.fullScreenSplit
      } else if (this.outLayout === 'custom') {
        return this.customSplit
      }
    },
    customProfileOptions () {
      let options = []
      for (let profile in this.profiles) {
        options.push({
          label: profile,
          value: profile,
          name: this.profiles[profile].name
        })
      }
      return options
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    _checkChanged (a, b) {
      let keys = Object.keys(a)
      for (let key of keys) {
        if (b[key] !== a[key]) return true
      }
      return false
    },
    applySingleAPI (apiName, dataKey, paramKey) {
      if (this._checkChanged(this[dataKey], this.editing[dataKey])) {
        let { mac } = this.$route.params
        let param = {
          [paramKey]: this.editing[dataKey]
        }
        call(mac, apiName, param).then(res => {
          this[dataKey] = _.cloneDeep(this.editing[dataKey])
        }, err => {
          this.alert('danger', '', err)
        })
      } else {
        this.alert('success', '', 'Nothing changed')
      }
    },
    updateRootMixerProfile (key, profile) {
      let { mac } = this.$route.params
      console.log(key)
      this.profiles[key] = _.cloneDeep(profile)
      this.$root.mixerProfile[mac][key] = _.cloneDeep(profile)
    },
    async updateProfile () {
      let mac = this.$route.params.mac
      let newProfile = {}
      let newSplitsAry = {}
      this.isUpdatingProfile = true
      try {
        for (let i = 1; i < 9; i++) {
          console.log(i)
          let { profiles } = await call(mac, 'dxGetProfiles', {
            profile: i.toString()
          })
          newProfile[i] = profiles
          newSplitsAry[i] = {
            setting: profiles.split
          }
        }

        this.profiles = _.cloneDeep(newProfile)
        this.splitsAry = _.cloneDeep(newSplitsAry)
        this.$root.mixerProfile[mac] = newProfile
        this.isUpdatingProfile = false
      } catch (err) {
        this.isUpdatingProfile = false
        this.alert('danger', '', err)
        console.error(err)
      }
    },
    applyOutputResolution () {
      if (this.editing.outResolution !== this.outResolution) {
        let { mac } = this.$route.params
        let param = {
          resolution: {
            '1': this.editing.outResolution
          }
        }
        call(mac, 'dxSetOutputResolution', param).then(res => {
          this.outResolution = _.cloneDeep(this.editing.outResolution)
          this.updateProfile()
        })
        .catch(err => {
          this.alert('danger', '', err)
        })
      } else {
        this.alert('success', '', 'Nothing changed')
      }
    },
    sendKeyToDevice (optionKey) {
      this.buttonDisabled = true
      let { mac } = this.$route.params
      call(mac, 'dxSetSplitByOption', {
        options: {
          '1': optionKey
        }
      }).then(res => {
        console.log('call splitArea done', res)
      }).catch(err => {
        console.error(err)
      })
    },
    sendProfileKeyToDevice (optionKey) {
      this.buttonDisabled = true
      let { mac } = this.$route.params
      call(mac, 'dxSetDeviceByProfileKey', { profile: optionKey }).then(res => {
        console.log(res)
      })
      .catch(err => {
        this.alert('danger', '', err)
      })
    },
    async applySourceLabel () {
      let keys = Object.keys(this.editing.sourceLabel)
      let targets = {}
      let { mac } = this.$route.params
      for (let k of keys) {
        if (this.editing.sourceLabel[k].text !== this.label.inputs[k].text) {
          targets[k] = {
            text: this.editing.sourceLabel[k].text,
            enabled: this.editing.sourceLabel[k].enabled
          }
        }
      }
      // console.log(targets)
      try {
        for (let key in targets) {
          console.log(key)
          await call(mac, 'dxSetLabel', {
            inputs: {
              [key]: targets[key]
            }
          })
        }
        console.log('dxSetLabel done')
      } catch (err) {
        console.error(err)
        this.alert('danger', '', err)
      }
    },
    addListener () {
      console.log('resize')
      this.ww = 0
      this.ww = window.innerWidth
      setTimeout(() => {
        this.$broadcast('render', '1')
      }, 200)
    },
    changeProps (outLayout, split, optionKey) {
      this.outLayout = outLayout
      if (outLayout === 'quick') {
        this.quickSelectSplit = split
      } else if (outLayout === 'full') {
        this.fullScreenSplit = split
      } else if (outLayout === 'custom') {
        this.buttonDisabled = true
        // this.customSplit = split // split 為 profile key
        // // change mapping
        // this.mapping = _.cloneDeep(this.profiles[split].mapping)

        // let newsplits = _.cloneDeep(this.splits)
        // let newLayer = _.cloneDeep(this.splitLayer)
        // newsplits.setting = this.profiles[split].split
        // newLayer = this.profiles[split].layer
        // this.splits = _.cloneDeep(newsplits)
        // this.splitLayer = _.cloneDeep(newLayer)
      }
      setTimeout(() => {
        this._applyScreenChg(optionKey)
      }, 100)
    },
    _applyScreenChg (optionKey) {
      this.$broadcast('render', '1')
      this.$broadcast('chgZindex', this.splitLayer, '1')
      if (this.outLayout === 'custom') {
        this.sendProfileKeyToDevice(optionKey)
      } else {
        this.sendKeyToDevice(optionKey)
      }
    }
  }, // close methods
  ready () {
    window.addEventListener('orientationchange', this.addListener, false)
    window.addEventListener('resize', this.addListener, false)
  },
  beforeDestroy () {
    window.removeEventListener('orientationchange', this.addListener, false)
    window.removeEventListener('resize', this.addListener, false)
  },
  events: {
    update (mac, {type, event, msg}) {
      console.log('got event:', type)
      switch (type) {
        case 'layer':
          this.splitLayer = event.layer
          setTimeout(() => {
            this.$broadcast('chgZindex', this.splitLayer, '1')
            this.buttonDisabled = false
          }, 700)
          break
        case 'mapping':
          let newMapping = _.cloneDeep(this.mapping)
          _.assignIn(newMapping, event)
          this.mapping = _.cloneDeep(newMapping)
          this.buttonDisabled = false
          break
        case 'split':
          let newSplit = _.cloneDeep(this.splits)
          _.assignIn(newSplit.setting, event.setting)
          this.splits = _.cloneDeep(newSplit)
          this.outLayout = 'init'
          setTimeout(() => {
            this.$broadcast('render', '1')
            this.buttonDisabled = false
          }, 700)
          break
        case 'label':
          console.log(event)
          let newLabel = _.cloneDeep(this.label)
          let {inputs = {}, windows = {}, custom = {}, osd = {}} = event

          if (inputs) _.assignIn(newLabel.inputs, event.inputs)
          if (windows) _.assignIn(newLabel.windows, event.windows)
          if (custom) _.assignIn(newLabel.custom, event.custom)
          if (osd) _.assignIn(newLabel.osd, event.osd)

          this.label = _.cloneDeep(newLabel)
          break
        case 'resolution':
          this.outResolution = event['1']
          setTimeout(() => {
            this.$broadcast('render', '1')
            this.$broadcast('chgZindex', this.splitLayer, '1')
            this.buttonDisabled = false
          }, 700)
          break
        case 'sound':
          let {soundFrom = '', soundRLChannel = '', fullScreenAudio = null, mute = null} = event
          let newSound = _.cloneDeep(this.outSound)

          if (soundFrom) newSound.soundFrom = soundFrom
          if (soundRLChannel) newSound.soundRLChannel = soundRLChannel
          if (fullScreenAudio !== null) newSound.fullScreenAudio = fullScreenAudio
          if (mute !== null) newSound.mute = mute

          this.outSound = _.cloneDeep(newSound)
          break
        case 'preset':
          let key = Object.keys(event)[0]
          this.updateRootMixerProfile(key, event[key])
          break
      }
    }
  },
  watch: {
    showOutSetting (nV) {
      if (nV) {
        this.editing.outSound = _.cloneDeep(this.outSound)
        this.editing.outColor = _.cloneDeep(this.outColor)
        this.editing.outVideo = _.cloneDeep(this.outVideo)
        this.editing.outResolution = _.cloneDeep(this.outResolution)
        this.editing.sourceLabel = _.cloneDeep(this.label.inputs)
      } else {
        this.outColorChanged = false
        this.outVideoChanged = false
        this.outSoundChanged = false
        this.outResolutionChanged = false
        $('.window_setting_modal').scrollTop(0)
      }
    }
  },
  route: { // add this code to index of every indexes
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    }
  }
}
</script>

<style scoped lang='scss'>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

/* for debug */
.config_title_bar{
  & h1.title{
    @include breakpoint(xs) {
      & span::after{
        content: 'xs';
        display: block;
      }
    }
    @include breakpoint(sm) {
      & span::after{
        content: 'sm';
        display: block;
      }
    }
    @include breakpoint(md) {
      & span::after{
        content: 'md';
        display: block;
      }
    }
    @include breakpoint(lg) {
      & span::after{
        content: 'lg';
        display: block;
      }
    }
  }
}


.setting{
  border-bottom: 1px solid $pri_gray
}

.function_section{
  margin-top: $space_xxs;
  @include breakpoint(xs){
    border-top: 1px solid $pri_gray;
  }
  @include breakpoint(landXS) {
    border-top: 1px solid $pri_gray;
  }
  padding-top: $space_xxs;
}

.quick__btn__single{
  width: 20%;
  padding: $space_xxs;
  @include breakpoint(sm) {
    width: 25%;
  }
  .btn{
    padding: 0;
  }
  img{
    width: 100%;
    height: 100%;
  }
}
.full_screen_btn_group{
  & .full__btn__single{
    & .btn{
      color: $base_white;
      font-weight: bold;
      font-size: 18px;
    }
    &:nth-of-type(1){
      & .btn{
        background-color: $window_a;
      }
    }
    &:nth-of-type(2){
      & .btn{
        background-color: $window_b;
      }
    }
    &:nth-of-type(3){
      & .btn{
        background-color: $window_c;
      }
    }
    &:nth-of-type(4){
      & .btn{
        background-color: $window_d;
      }
    }
  }
}

.custom__btn__single{
  margin-bottom: $space_xxs;
  .profile_name{
    font-size: 10px;
  }
}

.icon{
  width: 24px;
  height: 22px;
}

.window_setting{
  & .btn{
    margin-left: auto;
    margin-right: auto;
  }
  text-align: center;
  position:fixed;
  z-index:50;
  right:15px;
  top:40px;
  @include breakpoint(xs) {
    top: 38px;
  }
}

.btn, .btn:focus{
  outline: none;
}

/* for modal */
.modal-body{
  paddinfg-top: 0px;
}
.resolution_sec{
  padding-top: $space_xs;
}
.outer_group{
  padding-top: 0;
}
.effect__single{
  line-height: 30px;
  height: 30px;
  white-space: nowrap;
}
.sound_sec {
  & .fa_checkbox{
    font-size: 14px;
    margin-top: $space_xxs
  }
}
.sound__single{
  line-height: 35px;
}

.color__single{
  height: 76px;
}


.window_setting_modal {
  & .modal-body{
    padding-top: 15px;
  }
  & h3.title{
    border-bottom: 1px solid $BS_modal_inner_border;
    margin-bottom: 15px;
    margin-top: 0;
    padding-bottom: 7px;
  }
  .dropdown-menu{
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
    }
  }
}


/* for input[type=range] */

input[type=range] {
  -webkit-appearance: none;
  margin-bottom: $space_xs;
  width: 100%;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  animate: 0.2s;
  background: $pri_gray;
  border-radius: 1.3px;
  border:none;
}
input[type=range]::-webkit-slider-thumb {
  border: 1px solid $pri_dark;
  height: 20px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -6px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  /* background: #367ebd; */
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  animate: 0.2s;
  background: $pri_gray;
  border-radius: 1.3px;
  border:none;
}
input[type=range]::-moz-range-thumb {
  border: 1px solid $pri_dark;
  height: 20px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
}
input[tupe=range]:focus::-moz-range-thumb {
  outline: none;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
}
input[type=range]::-ms-fill-lower, input[type=range]::-ms-fill-upper {
  background: #aaa;
  border-radius: 2.6px;
  margin-top: -8px;
  height: 6px;
}

input[type=range]::-ms-thumb {
  border: 1px solid $pri_dark;
  margin-top: -10px;
  height: 14px;
  width: 10px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
}

.load_wrap{
  margin-top: -7px;
  position: fixed;
  left: 16.66667%;
  z-index: 50;
  padding-top: 0px;
  @include breakpoint(xxs) {
    left: 33%;
    margin-top: 0px;
    & .letter-holder{
      padding: 10px 16px 10px 28px;
    }
  }
}


.reminding{
  font-size: 12px;
  color: #f00;
}
/* for input[type=range] */

</style>



// WEBPACK FOOTER //
// Status.vue?223b9ac6